import React from 'react';
import { Link } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faEnvelope, faLocationDot } from '@fortawesome/free-solid-svg-icons';
import { faInstagram } from '@fortawesome/free-brands-svg-icons';


import './Menu.scss';

const Menu = ({ isOpen, isClosing, menuRef, toggleMenu }) => {
    

    return (
        <nav
            ref={menuRef}
            className={`menu ${isOpen ? 'open' : ''} ${isClosing ? 'closing' : ''}`}
            onClick={toggleMenu}
        >
            <div className='navigation'>
                <div className='navi__item'>
                    <Link className='navi__link' to='/repair'>Repair of Air Conditioner</Link>
                </div>
                <div className='navi__item'>
                    <Link className='navi__link' to='/maintenance'>Maintenance Service</Link>
                </div>
                <div className='navi__item'>
                    <Link className='navi__link' to='/freezer'>Construction of Refrigerated Freezers</Link>
                </div>
            </div>
            <div className='cont__links'>
                <div className='ig'>
                    <Link className='ig__link' target='_blank' to='https://www.instagram.com/sm_cold_inc?igsh=MTRydTA2bXg2NGVrdQ=='><FontAwesomeIcon className="fa__2x" icon={faInstagram} /></Link>
                </div>
                <div className='cont__item'>
                    <div className='cont__icon'>
                        <FontAwesomeIcon icon={faPhone} className="fa__2x" />
                    </div>
                    <div className='cont__touch'>
                        <Link className='cont__link' to='tel:+12153885043'>+1 215 388 50 43</Link>
                    </div>
                </div>
                <div className='cont__item'>
                    <div className='cont__icon'>
                        <FontAwesomeIcon icon={faEnvelope} className="fa__2x" />
                    </div>
                    <div className='cont__touch'>
                        <Link className='cont__link' to='mailto:smcold2023@gmail.com'>smcold2023@gmail.com</Link>
                    </div>
                </div>
                <div className='cont__item'>
                    <div className='cont__icon'>
                        <FontAwesomeIcon icon={faLocationDot} className="fa__2x" />
                    </div>
                    <div className='cont__touch'>
                        <Link className='cont__link' target='_blank' to='https://maps.app.goo.gl/QNJoFVxC8qzrnadx9'>300 Cottman Street, <br></br> Jenkintown, PA</Link>
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default Menu;